import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FeatureService} from "../../services/feature.service";
import {Feature} from "../../model/feature.model";
import {CommonModule} from '@angular/common';
import { IonAccordionGroup, IonAccordion, IonItem } from '@ionic/angular/standalone';
import {SexyModule} from '@qid/sexy';
import {SuperButtonComponent} from '@qid/super';

@Component({
  selector: 'list-feature',
  templateUrl: './list-feature.component.html',
  styleUrls: ['./list-feature.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    SuperButtonComponent,
    IonAccordionGroup,
    IonAccordion,
    IonItem
  ]
})
export class ListFeatureComponent implements OnInit {

  @Output() onAddCallback:(Feature)=>{}
  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  public showEditOptions : boolean = true;
  public showAddButton : boolean = false;
  public features: Feature[] = []
  public groupedFeatures: { group: string, features: Feature [] }[] = []

  constructor(private featureService: FeatureService) {
  }

  ngOnInit() {
    this.readAll();
  }


  async readAll() {
    this.features = await this.featureService.readAll();
    this.getAllFeaturesGroupedByFeatureGroup();
  }

  async getAllFeaturesGroupedByFeatureGroup() {
    const groupedFeatures: {} = this.features.reduce((result, feature) => {
      const featureGroup = feature.featureGroup?.name || "All Other";
      if (!result[featureGroup]) {
        result[featureGroup] = [];
      }
      result[featureGroup].push(feature);
      return result;
    }, {});


    this.groupedFeatures = Object.keys(groupedFeatures).map(function (group) {
      return {group: group, features: groupedFeatures[group]}
    });

  }

  onUpdateClicked(feature: Feature) {
    this.update.emit(feature);
  }

  delete = async (featureId) => {
    await this.featureService.delete(featureId)
    return this.readAll()
  }

  onAddClicked(feature: Feature) {
    this.onAddCallback(feature)
  }
}
